import { apiRequest } from 'utils/request'

export const getInputs = () =>
  apiRequest({
    uri: '/inputs/search',
    method: 'POST',
    readOnly: true,
    body: {
      count: 1000,
      startIndex: 1,
    },
  })

export const getOutputs = () =>
  apiRequest({
    uri: '/outputs/search',
    method: 'POST',
    readOnly: true,
    body: {
      count: 1000,
      startIndex: 1,
    },
  })

export const getPlatformLogicalSlots = ({ platform }) =>
  apiRequest({
    uri: `/logical-slots/${platform}`,
  })
